import React from "react";
import classNames from "classnames";

import classes from "./FormCard.module.scss";

interface FormCardProps {
  logo?: any;
  // className will be applied to topmost element
  className?: string;
  // className will be applied to topmost element
  style?: any;
  children: any;
}

// this component can be used as a parent div for consistent padding, border radius, etc
// TODO: put in the padding and border radius from figma, add comments to props
const FormCard: React.FC<FormCardProps> = ({
  children,
  logo,
  className,
  style,
}) => {
  return (
    <div
      className={classNames(classes.formCardMain, className)}
      style={{
        ...style,
      }}
    >
      <div className={classes.formCardLogo}>{logo ? logo : null}</div>
      {children}
    </div>
  );
};

export default FormCard;
